'use strict';

import {theme} from 'core_theme_1';

let paginationTemp = theme.templates.pageinationTemp;
let warningTemp = theme.templates.warningTemp;
let tourTemp = theme.templates.tourTemp;
let updatesTemp = theme.templates.updatesTemp;
let modelsTemp = theme.templates.modelsTemp;
let modelTemp = theme.templates.modelTemp;
let trailerTemp = theme.templates.trailerTemp;
let videoTemp = theme.templates.videoTemp;
let imageTemp = theme.templates.imageTemp;
let twoTwoFiveSevenTemp = theme.templates.twoTwoFiveSevenTemp;
let tocTemp = theme.templates.tocTemp;
let contactTemp = theme.templates.contactTemp;

// Local Templates override core
import joinTemp from './templates/join.html';
import affilatesTemp from './templates/affiliates.html';
import linksTemp from './templates/links.html';


export default function routes($stateProvider, $urlRouterProvider, $locationProvider, paginationTemplateProvider) {
  'ngInject';

  $locationProvider.html5Mode(true);

  paginationTemplateProvider.setString(paginationTemp);

  $urlRouterProvider.otherwise('/warning');

  $stateProvider
    .state({
      name: 'warning',
      url: '/warning',
      template: warningTemp,
      data: {
        title: 'Welcome',
        showMenu: false
      }
    })
    .state({
      name: 'tour',
      url: '/tour',
      template: tourTemp,
      controller: 'tourCtrl',
      controllerAs: 'tour',
      data: {
        title: 'Tour',
        showMenu: true
      }
    })
    // because these states use pagination they have to be
    // controllerAs .. vm
    .state({
      name: 'updates',
      url: '/updates?:pageNum',
      template: updatesTemp,
      controller: 'updatesListCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Updates',
        showMenu: true
      }
    })
    .state({
      name: 'models',
      url: '/models?:pageNum?:order',
      template: modelsTemp,
      controller: 'modelsListCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Models',
        showMenu: true
      }
    })
    .state({
      name: 'model',
      url: '/model?:modelId?:pageNum',
      template: modelTemp,
      controller: 'modelCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Model Details',
        showMenu: true
      }
    })
    .state({
      name: 'login',
      url: '/login',
      controller: 'loginCtrl',
      controllerAs: 'login'
    })
    .state({
      name: 'join',
      url: '/join',
      template: joinTemp,
      controller: 'joinCtrl',
      controllerAs: 'join',
      data: {
        title: 'Join',
        showMenu: true
      }
    })
    .state({
      name: 'trailer',
      url: '/trailer/:updateId',
      template: trailerTemp,
      controller: 'trailerCtrl',
      controllerAs: 'trailer',
      data: {
        title: 'Trailer',
        showMenu: true
      }
    })
    .state({
      name: 'video',
      url: '/video/:updateId',
      template: videoTemp,
      controller: 'videoContentCtrl',
      controllerAs: 'video',
      data: {
        title: 'Members Video',
        showMenu: true
      }
    })
    .state({
      name: 'image',
      url: '/image?:videoId:imageIdx',
      template: imageTemp,
      controller: 'imageContentCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Members Image',
        showMenu: true
      }
    })
    .state({
      name: '2257',
      url: '/2257',
      template: twoTwoFiveSevenTemp,
      data: {
        title: '18 U.S.C. 2257 Statement',
        showMenu: true
      }
    })
    .state({
      name: 'toc',
      url: '/toc',
      template: tocTemp,
      data: {
        title: 'Terms And Conditions',
        showMenu: true
      }
    })
    .state({
      name: 'affiliates',
      url: '/affiliates',
      template: affilatesTemp,
      data: {
        title: 'Affiliates',
        showMenu: true
      }
    })
    .state({
      name: 'links',
      url: '/links',
      template: linksTemp,
      data: {
        title: 'Spank My Bottom Links',
        showMenu: true
      }
    })
    .state({
      name: 'contact',
      url: '/contact',
      template: contactTemp,
      data: {
        title: 'Contact Us',
        showMenu: true
      }
    })
  /*
    .when('/models/order/:order', {
      template: modelsTemp,
      controller: 'modelsCtrl as vm',
      title: 'Models',
      reloadOnSearch: false
    })
*/
}



// WEBPACK FOOTER //
// ./src/app/app.routes.js